import {EnvironmentConfig} from './environment.config';

export const environment = {
  live: true,
  environmentName: 'Development',
  baseUrl: 'https://dev-pbm.greydom.com/api',
  baseWeUrl: 'https://dev-we.greydom.com/api',
  baseClmUrl: 'https://dev-clm.greydom.com/api',
  baseItsUrl: 'https://dev-its.greydom.com/api',
  baseIgnUrl: 'https://dev-ign.greydom.com/api',
  baseEngineUrl: 'https://app-dev.ruleslab.com',
  baseAuthorUrl: 'https://app-dev.ruleslab.com',
  baseReportingUrl: 'https://dev-rpt.greydom.com/jasperserver',
  serviceDeskRequestsUrl: 'https://greydom.atlassian.net/servicedesk/customer/user/requests?page=1',
  reportingCredentials: 'j_username=endpoint_user_internal&j_password=fjeH5HdMqmh*4eJ9',
  contextRoute: '',
  portalRoute: EnvironmentConfig.portalRoute.normal,
  keycloak: {
    url: 'https://dev-auth.greydom.com/auth/',
    realm: 'greydom',
    clientId: 'greydom-angular-develop',
    redirectOverrideUrlEnterprise: '',
    redirectOverrideUrlProvider: '',
    redirectOverrideUrlOnboarding: '',
    redirectOverrideUrlBroker: ''
  },
  submitAuthToIgn: false,
  submitClaimToIgn: false,
  allowNormalPortalAccess: true,
  allowProviderPortalAccess: true,
  allowSubmitClaimForProviderPortal: true,
  allowSubmitAuthForProviderPortal: true,
  allowSubmitClaimForNormalPortal: true,
  allowSubmitAuthForNormalPortal: true,
  allowGeneralPractitionerDrugsOnly: false,
  allowGovernmentData: true,
  allowHealthCloudScore: true,
  allowBrokerPortalAccess: true,
  claimManagementFeatures: {
    cases: true,
    payments: true
  },
  defaultPracticeNumber: '',
  primarySubClass: 'None',
  requireCaseToCaptureTransaction: false,
  defaultProviderLabel: 'Provider Name',
  timeZone: 'UTC',
  encounterOverrideIndicators: {
    overrideIndicator1: 'Network Override',
  },
  activityOverrideIndicators: {
    overrideIndicator1: 'Out Of Formulary Override',
    overrideIndicator2: 'Early Refill Override',
    overrideIndicator3: 'Extended Supply Override',
    overrideIndicator4: 'Pay As Claimed Override',
    manualCopaymentOverride: 'Manual Copayment Override',
  },
  jiraWidget: {
    showWidget: true,
    dataKey: EnvironmentConfig.jiraWidgetKeys.Greydom
  },
  jiraApi: {
    enabled: true,
    baseUrl: 'https://greydom.atlassian.net',
    serviceDeskId: '36',
    keyPrefix: 'TSM'
  },
  theme: EnvironmentConfig.themes.Greydom,
  favicon: EnvironmentConfig.favicon.Greydom,
  showPoweredByOverride: false,
  vatPercentage: EnvironmentConfig.vatPercentage,
  externalClientUrl: EnvironmentConfig.externalClientUrl.Empty,
  acceptedApplicationLookBackDays: EnvironmentConfig.acceptedApplicationLookBackDays,
  applicationCapture: EnvironmentConfig.applicationCapture,
  schema: EnvironmentConfig.schema
};
